import React from "react";
import PropTypes from "prop-types";
import OrganizerStructureItem from "./tree/OrganizerStructureItem";

/**
 * OrganizerStructureBrowser: props => React element
 *
 * (c) Stefan Wittwer 2018 | Alle Rechte vorbehalten.
 *
 * Structure browser, representing the left-hand side
 * of the Organizer
 *
 * @param {*} props
 */
const OrganizerStructureBrowser = props => (
  <div>
    {props.contexts.map(context => (
      <OrganizerStructureItem
        title={context.displayName}
        name={context.id}
        key={context.id}
        onSelect={() => props.selectContext(context.id)}
        isSelected={context.id === props.currentContext}
      />
    ))}
  </div>
);

OrganizerStructureBrowser.propTypes = {
  /**
   * List of contexts currently accessible by the user
   */
  contexts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired
    })
  ).isRequired,
  /**
   * Function to select the specified context in the Organizer
   */
  selectContext: PropTypes.func.isRequired,
  /**
   * Currently selected context in the Organizer
   */
  currentContext: PropTypes.string
};

OrganizerStructureBrowser.defaultProps = {
  currentContext: null
};

export default OrganizerStructureBrowser;



// WEBPACK FOOTER //
// ./src/modules/organizer/OrganizerStructureBrowser.js